import { Validators } from "@angular/forms";
import { CustomDropDownListOptions } from "../custom-drop-down-list/customDropDownList.interface";
import { TemplateRef } from "@angular/core";

export interface DynamicFormOptions {
  buttonAtBottom?: boolean;
  areas?: DynamicFormArea[];
  formType?: 'edit' | 'add' | 'view';
  editOptions?: DynamicFormEditOptions;
  addOptions?: DynamicFormAddOptions;
}

export interface DynamicFormEditOptions{
  entityName: string;
  entityId: string;
  entityDisplayName: string;
  isFem: boolean;
  deleteUrl: string;
  deleteItem: string;
  deleteMessage: string;
  redirectUrl: string;
}

export interface DynamicFormAddOptions{
  entityName: string;
  entityDisplayName: string;
  isFem: boolean;
  redirectUrl: string;
}

export interface DynamicFormArea{
  name?: string;
  cssClass?:string;
  width?: 'w-1/2' | 'w-full' | 'w-1/3' | 'w-2/3' | 'w-1/4' | 'w-2/4' | 'w-3/4' ;
}

export interface Validator {
  name: string;
  validator: Validators;
  message: string;
  delay?: number;
}
export interface FieldConfig {
  hidden?: boolean;
  label?: string;
  name: string;
  placeholder?: string;
  inputType?: string;
  options?: any;
  allowAdd?: boolean,
  data?: Array<any>
  collections?: any;
  type: FieldTypeEnum;
  isRequired?: boolean;
  width?: 'w-1/2' | 'w-full' | 'w-1/3' | 'w-2/3' | 'w-1/4' | 'w-2/4' | 'w-3/4' | 'w-1/5' | 'w-2/5' | 'w-3/5' | 'w-4/5' | 'w-1/6' | 'w-1/12' | 'w-2/6'
  //type: 'select' | 'button' | 'input' | 'switch' | 'checkbox' | 'multi' | 'fake'| 'separator'|'date';
  buttonType?: 'submit' | 'button' | 'cancel' | 'delete' | 'normal' | 'unlock';
  buttonId?: number;
  value?: any;
  cssClass?: string;
  multiple?: boolean;
  fullWidth?: boolean;
  toggleLablePosition?: string;
  isDisabled?: boolean;
  validations?: Validator[];
  buttonMenuItems?: Array<any>;
  textareaRow?: number;
  textAreaShape?: string;
  activationField?: string;
  activationFieldValue?: any;
  formGroupClass?: any;
  typeAheadOptionField?: string;
  readonly?: boolean;
  showEmptyOption?: boolean;
  autoFocus?: boolean;
  additionalClass?: string;
  message?: string;
  tooltip?: string;
  ignorePositioning?: boolean;
  fileUploadType?: string;
  noBase64?: boolean;
  embedRef?: TemplateRef<any>;
  emptyMsg?: string;
  itemsCount?: number;
  area?: number
}

export interface SelectedFiles {
  name: string;
  file: any;
  base64?: string;
}

export enum FormValidatorsList {
  maxlength = 'maxlength',
  required = 'required',
  pattern = 'pattern',
  minlength = 'minlength',
  max = 'max',
  compose = 'compose',
  email = 'email',
  nullvalidator = 'nullvalidator',
  apply = 'apply',
  arguments = 'arguments',
  prototype = 'prototype'
}

export enum FieldTypeEnum {
  select = 'select',
  button = 'button',
  input = 'input',
  numberInput = 'numberInput',
  password = 'password',
  switch = 'switch',
  checkbox = 'checkbox',
  upload = 'upload',
  //fake = 'fake',
  //separator = 'separator',
  date = 'date',
  time = 'time',
  dateTime = 'datetime',
  //buttonGroup = 'buttonGroup',
  radioButton = 'radiobutton',
  textarea = 'textarea',
  divider = 'divider',
  title = 'title',
  color = 'color',
  file = 'file',
  embed = 'embed',
  itemSelect = 'itemSelect',
  autoComplete = 'autoComplete'
}

export interface FormFieldsErrors {
  title: string;
  details?: string;
}


export interface FormFieldHighlight {
  name: string;
  message: string;
}

export interface LockServerRequest {
  tableName: string;
  id: string;
  session: string;
}